(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@thx/ducks"), require("immutable"), require("debug"), require("lodash/set"), require("lodash/get"));
	else if(typeof define === 'function' && define.amd)
		define(["@thx/ducks", "immutable", "debug", "lodash/set", "lodash/get"], factory);
	else if(typeof exports === 'object')
		exports["meteor-redux-middleware"] = factory(require("@thx/ducks"), require("immutable"), require("debug"), require("lodash/set"), require("lodash/get"));
	else
		root["meteor-redux-middleware"] = factory(root["@thx/ducks"], root["immutable"], root["debug"], root["lodash/set"], root["lodash/get"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition